const translation = {
    // Langs (Keep them like this, as they are used in the language switcher)
    'English': 'English',
    'Français': 'Français',
    'Español': 'Español',

    // CUSTOM TRANSLATIONS
    'i_agree_to_the': "J'accepte la",
    'Privacy Policy': 'Politique de Confidentialité',
    'and': 'et',
    'Terms of Service': "Conditions d'Utilisation",
    'Send Message': 'Envoyer le Message',
}

export { translation };
